// extracted by mini-css-extract-plugin
export default {"error":"Error-module--error--dda51"};